import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: "David D. Gaviria's portfolio", // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: "Welcome to my website, I'm a Multimedia Engineer that loves AI. Get in touch!", // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: "Hi, I'm", // Hello, my name is
  name: 'David D. Gaviria.', // John
  subtitle: 'Welcome!', // I'm the Unknown Developer.
  cta: 'Know more', // Know more
};

// ABOUT DATA
export const aboutData = {
  img: 'me.jpeg',
  paragraphOne: 'Hello',
  paragraphTwo:
    "I'm a Multimedia Engineer with a master's degree in Artificial Intelligence who loves combining interactive concepts with Machine Learning and Deep Learning, as well as all things related to computer science, innovation and cutting edge technology!",
  paragraphThree: 'Click bellow if you need some insights on me!',
  resume: 'CV_David_D_Gaviria.pdf', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'skinlesion.png',
    title:
      'Application of Deep Learning Models based on Convolutional Neural Networks and Vision Transformers for Skin Lesion Classification',
    info:
      'Deployment via web application of a model that placed first in the 2019 SIIM-ISIC Challenge, our goal with this project was to compare the performance of Vision Transformers to that of Convolutional Neural Networks and show that, regardless of the performance of either architecture, an ensemble of both can improve generalization.',
    info2:
      'We also present a model extension and an extension to the Gram-OOD method for out-of-distribution samples on medical skin lesion images. A demo of a web app is available bellow.',
    url: 'https://skin-lesion-diagnosis.web.app/',
    repo: 'https://github.com/blobquiet/SIIM-ISIC-Melanoma-Classification', // if no repo, the button will not show up
    more:
      'https://skin-lesion-diagnosis.web.app/_David_D__Gaviria__Superconverging_Deep_Learning_Model_for_Skin_Lesion_Classification.pdf',
  },
  {
    id: nanoid(),
    img: 'mlagents.png',
    title: 'Hide and Seek simulation with Reinforcement Learning',
    info:
      'There are two main types of agents the hiders and the seekers. Each has equal rights of movement and to move objects in the environment.',
    info2:
      'The vision abilities of the agents are approximated by implementing raycasting component, which help the agents locate objects within their visual field.',
    url: 'https://www.youtube.com/watch?v=JhDLelpUSJU',
    repo:
      'https://github.com/blobquiet/Hider-and-Seeker-with-Reinforcement-Learning-Unity-ML-Agents-', // if no repo, the button will not show up
    more: 'https://drive.google.com/file/d/12wwRcMHF5alRkOfA5pQJiq3aoQJM1pZX/view',
  },
  {
    id: nanoid(),
    img: 'ada.png',
    title: 'Ada: a motion and speech recognition robot',
    info:
      'The robot Ada is capable of responding by movement to simple keywords from the users, using two separate aspects.',
    info2:
      'The first is a speech recognition algorithm, using Machine Learning on an Arduino Nano 33 BLE Sense as the cognitive side, built on Edge Impulse. The second is to use this Arduino chip to control a physical robot, known under the name of Otto, able to move around accordingly to what was understood.',
    url: 'https://www.youtube.com/watch?v=UjGXaB7CqaM',
    repo: 'https://github.com/blobquiet/Emotive-Robot-Companion-CIR', // if no repo, the button will not show up
    more:
      'https://github.com/blobquiet/Emotive-Robot-Companion-CIR/blob/main/Ada_Emotive_Robot_Companion.pdf',
  },
  {
    id: nanoid(),
    img: 'iMxp.png',
    title: 'iMxp, a Virtual Reality and Augmented Reality multimedia experience',
    info:
      'An app that allows users to hold 3D objects and animations using augmented reality through a physical cube, in which it is possible to interact digitally.',
    info2:
      'In addition to be able to see a Media Lab through a portal in which he/she can visit other places with augmented reality, to make it a much more immersive experience.',
    url: 'https://youtu.be/RYUL2WuqgRc',
    repo: '', // if no repo, the button will not show up
    more: 'https://red.uao.edu.co/handle/10614/11084',
  },
  {
    id: nanoid(),
    img: 'uao.png',
    title: 'Vive la UAO, a virtual campus of a university',
    info:
      'With this application you can access different spaces of the UAO University, through videos, 360 photos and augmented reality.',
    info2:
      'You can also do the guided tours, discover what they do in each of their facilities and have fun with the gymkhana while you discover the different challenges we have.',
    url: 'https://apps.apple.com/es/app/vive-la-uao/id1491069767',
    repo: '', // if no repo, the button will not show up
    more: 'https://www.instagram.com/p/B816jJbHAYo/',
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'If you have an idea that you want to discuss? Awesome!',
  btn: "Let's talk!",
  email: '',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/daviddgaviria',
    },
    {
      id: nanoid(),
      name: 'instagram',
      url: 'https://www.instagram.com/so_quiet/',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/david-d-gaviria-313288161/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/blobquiet?tab=repositories',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
